import { IFeatureBase, IFeatureGroupBase } from '../../models/features';
import { IVentureBase } from '../../models/ventures';
import { IUserAssignmentBase, IUserOnboardBase } from '../../models/users';
import jhsfBookingsApi from '../apis/jhsfBookingsApi';
import { IVentureExperienceLevelBase } from '../../models/ventureExperienceLevels';

interface IRefreshSessionFeatureGroup extends IFeatureGroupBase {
  features: IFeatureBase[];
}

interface IRefreshSessionVenture extends IVentureBase {
  experienceLevels: IVentureExperienceLevelBase[];
}

interface IRefreshSessionUserAssignment extends IUserAssignmentBase {
  featureGroup: IRefreshSessionFeatureGroup;
}

export interface IRefreshSession {
  sessionUserAssignment: IRefreshSessionUserAssignment;
  sessionUserVentureOnboard?: IUserOnboardBase;
  sessionVenture?: IRefreshSessionVenture;
  token: string;
  refreshToken: string;
}

interface IRefreshSessionProps {
  refreshToken: string;
  ventureId?: string;
}

export const refreshSessionsService = async ({
  refreshToken,
  ventureId,
}: IRefreshSessionProps): Promise<IRefreshSession> => {
  const { data } = await jhsfBookingsApi.put<IRefreshSession>(
    '/sessions/refresh',
    {
      refreshToken,
      ventureId,
    },
  );

  return data;
};
